import workshop from "../content/thumbnails/workshop.png";

export default [
  {
    title: "Stellar Indonesia Workshop - Blockdev.id",
    path: "https://www.instagram.com/p/DQB8HwQCfse/",
    img: workshop,
  },
  {
    title: "Introduction to Kotlin - JeparaDev",
    path: "https://www.instagram.com/p/B1h9BO5g-x-/",
    img: workshop,
  },
];
